// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { InstitutionForm } from '@client/banks/components/shared/institution-form';
import { BankDetailsDrawer } from '@client/banks/layouts/bank-details-drawer';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { FormProvider } from 'react-hook-form';
import {
  BANK_INSTITUTION_UPDATE_FORM_ID,
  useBankInstitutionUpdateDrawer,
} from './use-bank-institution-update-drawer';

export const BankInstitutionUpdateDrawer = defineComponent({
  displayName: 'BankInstitutionUpdateDrawer',
  useSetup: useBankInstitutionUpdateDrawer,
  View: ({
    institution,
    open,
    onClose,
    onDelete,
    form,
    onSubmit,
    onSave,
    isSaveDisabled,
    isSaveLoading,
  }) => (
    <BankDetailsDrawer
      institution={institution}
      open={open}
      onClose={onClose}
      onDelete={onDelete}
      onSave={onSave}
      isSaveDisabled={isSaveDisabled}
      isSaveLoading={isSaveLoading}
      title={
        <Translation
          i18nKey="aggregator.create-bank.institution.form-title-edit"
          ns="aggregator"
        />
      }
      description={
        <Translation
          i18nKey="aggregator.create-bank.institution.manual-description"
          ns="aggregator"
        />
      }
    >
      <FormProvider {...form}>
        <InstitutionForm
          formId={BANK_INSTITUTION_UPDATE_FORM_ID}
          onSubmit={onSubmit}
        />
      </FormProvider>
    </BankDetailsDrawer>
  ),
});
